import agriculture from "../../../assets/sector-wheel-images/agriculture.png";
import aviationaviationinfrastructure from "../../../assets/sector-wheel-images/aviationaviationinfrastructure.png";
import electronics from "../../../assets/sector-wheel-images/electronics.png";
import healthcare from "../../../assets/sector-wheel-images/healthcare.png";
import itites from "../../../assets/sector-wheel-images/it-ites.png";
import mining from "../../../assets/sector-wheel-images/mining.png";
import oilgas from "../../../assets/sector-wheel-images/oil&gas.png";
import roadshighways from "../../../assets/sector-wheel-images/roads&highways.png";
import shipping from "../../../assets/sector-wheel-images/shipping.png";
import textiles from "../../../assets/sector-wheel-images/textiles.png";
import railways from "../../../assets/sector-wheel-images/railways.png";
import chemicals from "../../../assets/sector-wheel-images/chemicals.png";
import foodProcessing from "../../../assets/sector-wheel-images/foodProcessing.png";
import automobile from "../../../assets/sector-wheel-images/automobile.png";
import defence from "../../../assets/sector-wheel-images/defence.png";
import retailShops from "../../../assets/sector-wheel-images/retailShops.png";
import leather from "../../../assets/sector-wheel-images/leather.png";
import pharma from "../../../assets/sector-wheel-images/pharma.png";
import biotech from "../../../assets/sector-wheel-images/biotech.png";
import coal from "../../../assets/sector-wheel-images/coal.jpg";
import cement from "../../../assets/sector-wheel-images/cement.jpg";
import education from "../../../assets/sector-wheel-images/education.jpg";
import inlandWaterways from "../../../assets/sector-wheel-images/Inland waterways.jpg";
import powerGeneration from "../../../assets/sector-wheel-images/powerGeneration.jpg";
import powerTransmission from "../../../assets/sector-wheel-images/power-transmission.jpg";
import realEstate from "../../../assets/sector-wheel-images/real estate.jpg";
import steel from "../../../assets/sector-wheel-images/steel.jpg";
import metro from "../../../assets/metrosector.jpg";
import publicworks from "../../../assets/publicworks.jpg";
import space from "../../../assets/sector-wheel-images/space.jpg";
import gems from "../../../assets/sector-wheel-images/gems.jpg";
import logisticsPark from "../../../assets/sector-wheel-images/logisticsPark.jpg";
import wasteWater from "../../../assets/sector-wheel-images/waste & water.jpg";
import publicSpace from "../../../assets/sector-wheel-images/public space development.jpg";
import machineryEquipment from "../../../assets/sector-wheel-images/Machinery & Equipment.jpg";
import tourismHospitalityWellness from "../../../assets/sector-wheel-images/tourism,hospitality&wellness.png";

export const getPath = sectorName => {
  switch (sectorName) {
    case "Healthcare":
      return healthcare;
    case "Roads & Highways":
      return roadshighways;
    case "Power Generation":
      return powerGeneration;
    case "Railways":
      return railways;
    case "Oil & Gas":
      return oilgas;
    case "Coal":
      return coal;
    case "Steel":
      return steel;
    case "Public Works":
      return publicworks;
    case "Metro":
      return metro;
    case "Cement":
      return cement;
    case "Shipping":
      return shipping;
    case "Mining":
      return mining;
    case "Real Estate":
      return realEstate;
    case "Agriculture":
      return agriculture;
    case "Aviation & Aviation Infrastructure":
      return aviationaviationinfrastructure;
    case "Chemicals":
      return chemicals;
    case "IT/ITES":
      return itites;
    case "Inland Waterways":
      return inlandWaterways;
    case "Education":
      return education;
    case "Electronics":
      return electronics;
    case "Public Space Development":
      return publicSpace;
    case "Textiles":
      return textiles;
    case "Tourism, Hospitality & Wellness":
      return tourismHospitalityWellness;
    case "Waste & Water":
      return wasteWater;
    case "Food Processing":
      return foodProcessing;
    case "Automobile":
      return automobile;
    case "Defense Production":
      return defence;
    case "Retail Chains & Shops":
      return retailShops;
    case "Leather":
      return leather;
    case "Pharmaceuticals":
      return pharma;
    case "BioTech":
      return biotech;
    case "Power Transmission & Distribution":
      return powerTransmission;
    case "Logistics Park":
      return logisticsPark;
    case "Heavy Machinery & Equipment":
      return machineryEquipment;
    case "Space":
      return space;
    case "Gems and Jewellery":
      return gems;
    default:
      return "";
  }
};

export const setSectorDropdownData = (list = []) => {
  return (
    list &&
    list.map(item => {
      item.value = item.sectorId;
      item.label = item.sectorName;
      return item;
    })
  );
};

export const setStateDropdownData = (list = []) => {
  return (
    list &&
    list.map((item, index) => {
      item.value = index;
      item.label = item.stateName;
      return item;
    })
  );
};
